module.exports = __webpack_public_path__ + "54fa6fc769554307072382e25395c2b4.png";